// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mawile: PokeData = {
  "id": 303,
  "name": "mawile",
  "height": 6,
  "weight": 115,
  "base_experience": 133,
  "types": [
    PokeType.STEEL,
    PokeType.FAIRY
  ],
  "api_moves": [
    "vice-grip",
    "bite",
    "growl",
    "feint-attack",
    "baton-pass",
    "sweet-scent",
    "crunch",
    "stockpile",
    "spit-up",
    "swallow",
    "taunt",
    "astonish",
    "fake-tears",
    "iron-defense",
    "sucker-punch",
    "iron-head",
    "play-rough",
    "fairy-wind"
  ],
  "moves": [
    "bite",
    "growl",
    "crunch",
    "play-rough",
    "metal-sound",
    "starfall",
    "misty-terrain",
    "steel-beam",
    "mist-terrain",
    "moonlight",
    "sweet-kiss",
    "spirit-break",
    "metal-rush"
  ],
  "evolution_chain": {
    "id": 150,
    "item": null,
    "species": [
      {
        "name": "mawile",
        "order": 329,
        "types": [
          PokeType.STEEL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 100,
    "ability_power": 170
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
